'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var arrays = require('./arrays.js');

const generatePassword = (length = 10) => {
  if (length < 4) {
    throw new Error("stringLength must be at least 4");
  }
  const numberChars = "0123456789";
  const upperChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowerChars = "abcdefghijklmnopqrstuvwxyz";
  const specialChars = '!"#$%&()*+,-./:;<=>?@[]^_`{|}~';
  const dictionary = [numberChars, upperChars, lowerChars, specialChars];
  const result = [];
  for (let i = 0; i < length; i++) {
    const index = i % dictionary.length;
    result.push(dictionary[index][Math.floor(Math.random() * dictionary[index].length)]);
  }
  return arrays.shuffle(result).join("");
};

exports.generatePassword = generatePassword;
